import { IIdName } from '@/interfaces/general/IIdName.ts';

export const PERIOD_FREQUENCY_OPTIONS: Array<IIdName> = [
    { name: 'Hourly', id: '24', info: 'Periods of one hour, 24 periods per day' },
    { name: 'Half-hourly', id: '48', info: 'Periods of 30 minutes, 48 periods per day' },
    { name: 'Quarter-hourly', id: '96', info: 'Periods of 15 minutes, 96 periods per day' },
];
